//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model.fragment

import blazern.lexisoup.graphql.model.type.Sentence
import kotlin.String

public data class SentenceFields(
  public val text: String,
  public val langIso3: String,
  public val source: String,
) : Sentence.Data
